import { JustificationType } from '../utils/types/daily-work';
import { User } from './user';

export enum DailyWorkType {
  BEGIN = 'begin',
  START_LOUNCH = 'start_lounch',
  END_LOUNCH = 'end_lounch',
  FINISH = 'finish',
}

export enum WorkType {
  WORK = 'work',
  JUSTIFICATION = 'justification',
  FAULT = 'fault',
  SCHEDULED = 'scheduled',
}

export type DailyWork = {
  id: number;
  user: User;
  begin?: string;
  start_lounch?: string;
  end_lounch?: string;
  finish?: string;
  price?: string;
  isPaid: boolean;
  isBankHour: boolean;
  description?: string;
  createdBy?: string;
  deletedAt?: string;
  deletedBy?: string;
  type: WorkType;
  justification?: JustificationType;
  isCompensation: boolean;
  workTime?: number;
  accumulatorTime?: number;
  lounchTime?: number;
  justificationTime?: number;
  justificatedBy?: string;
  location?: string;
  access_code?: string;
};

export type DailyWorkResponse = Omit<DailyWork, 'user'> & {
  username: string;
  totalValue: string;
  workHours: string;
  user: number;
  role?: string;
};
